import { SET_GLOBAL_LOADING, SET_OFFLINE_MODE } from '../actions/Index';

const initState = {
  isOffline: false,
  globalSyncLoading: false,
};

export default function (state = initState, action: any): any {
  const { type, payload } = action;
  switch (type) {
    case SET_OFFLINE_MODE:
      return {
        ...state,
        isOffline: payload.isOffline
      };
    case SET_GLOBAL_LOADING:
      return {
        ...state,
        globalSyncLoading: payload,
      };
    default:
      return state;
  }
} 